import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { Link, Tooltip } from '@mui/material';
import { parseFormulaParts } from './PriceResFormulaUtils';

// Shared by PriceResFormulaCellRenderer and PriceResFormulaFormField. Renders a formula with each
// bracketed var code tooltipped with the value used at eval time (sourced from tierVars' JSON),
// except [PROG:<id>] tokens, which are hyperlinked to that Prog's detail page using its name from vars.
export const PriceResFormulaContent = ({ formula, vars }) => {
  const { navigateTo } = useNavState();

  if (!formula) return null;

  let codeToValue = {};
  try {
    codeToValue = vars ? JSON.parse(vars) : {};
  } catch {
    codeToValue = {};
  }

  const parts = parseFormulaParts(formula);

  return (
    <span>
      {parts.map((part, index) => {
        if (!part.code) return <span key={index}>{part.text}</span>;

        if (part.code.startsWith('PROG:')) {
          const progId = part.code.slice('PROG:'.length);
          return (
            <Link
              key={index}
              onClick={(event) => navigateTo('md/prog', { entityId: progId, mode: Mode.DETAIL }, event.ctrlKey)}
              sx={{ cursor: 'pointer' }}
            >
              {codeToValue[part.code] ?? part.text}
            </Link>
          );
        }

        // Undefined means the var code wasn't in vars at eval time (distinct from a real 0)
        return (
          <Tooltip key={index} title={`${part.code} = ${codeToValue[part.code] ?? '0'}`}>
            <span style={{ textDecoration: 'underline dotted', cursor: 'help' }}>{part.text}</span>
          </Tooltip>
        );
      })}
    </span>
  );
};
